module.exports = __webpack_public_path__ + "public/Icons/lightModeOn.svg?2d61d3aa";